<template>
  <div>
    <PPagination :current-page="page" :total="total" :page-size="pageSize" @change="onPaginationChange" class="mb-1" />
    <PTable :table="table" caption="" :version="2" aria-label="Versions du site" >
      <template #column.body="{ row }">
        <ul>
          <li v-for="(item, index) in row.body" :key="index">
            <OhVueIcon :name="dotIcon" scale="1.5" class="pt-1v" />
            {{ item }}
          </li>
        </ul>
      </template>
    </PTable>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useVersionAnnouncementStore } from "./version-announcement.store";
import { type PastaTableColumnDefArgs, usePastaTable, PTable, PPagination, useIcons } from "@pasta/box-v2";
import { type VersionAnnouncementDto } from "./version-announcement.dto";
import { BiDot } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";

const [dotIcon] = useIcons(BiDot);

const versionsStore = useVersionAnnouncementStore();
const versions = computed(() =>
  versionsStore.list.data.filter(
    (_item, index) => index >= (page.value - 1) * pageSize.value && index < page.value * pageSize.value
  )
);

const columns: PastaTableColumnDefArgs<VersionAnnouncementDto>[] = [
  { type: "simple", key: "number", label: "Version", weight: 1 },
  { type: "simple", key: "releaseDate", label: "Date", weight: 3 },
  { type: "simple", key: "body", label: "Contenu", weight: 8 },
];

const table = usePastaTable({ data: versions, columns });

const page = ref(1);
const pageSize = ref(100);
const total = computed(() => versionsStore.list.data.length);

function onPaginationChange(pagination: { page: number; pageSize: number }) {
  if (pagination.pageSize !== pageSize.value) {
    page.value = 1;
  } else {
    page.value = pagination.page;
  }
  pageSize.value = pagination.pageSize;
}
</script>
